import React from 'react';
import {
  GoogleMap,
  Marker,
  Polyline,
  withGoogleMap,
  withScriptjs,
  GoogleMapProps
} from 'react-google-maps';
import PinSource from '../../../../assets/img/pin_source.png';
import PinDestination from '../../../../assets/img/pin_destination.png';
import PinCurrent from '../../../../assets/img/pin_current.png';

interface TransferMapProps {
  googleMapURL: string;
  loadingElement: React.ReactElement;
  containerElement: React.ReactElement;
  mapElement: React.ReactElement;
  center: { latitude: string; longitude: string };
  customer?: any;
  nosocomio?: any;
  currentPosition?: any;
  path1?: any;
  path2?: any;
  directions?: any;
  colorStroke?: string;
  mode?: string;
}

const TransferMapBase: React.FC<TransferMapProps> = (props) => {
  const mapProps: GoogleMapProps = {
    defaultZoom: 14,
    defaultCenter: {
      lat: parseFloat(props.center.latitude),
      lng: parseFloat(props.center.longitude),
    },
    defaultOptions: {
      scrollwheel: false,
    },
  };

  // Helper para evitar errores si window.google no está definido
  const getSize = () => {
    try {
      // @ts-ignore
      return typeof window !== 'undefined' && window.google && window.google.maps && window.google.maps.Size ? new window.google.maps.Size(48, 48) : undefined;
    } catch {
      return undefined;
    }
  };
  const getPoint = () => {
    try {
      // @ts-ignore
      return typeof window !== 'undefined' && window.google && window.google.maps && window.google.maps.Point ? new window.google.maps.Point(20, 15) : undefined;
    } catch {
      return undefined;
    }
  };

  return (
    <GoogleMap {...mapProps}>
      {/* Cliente (origen) */}
      {props.customer && (
        <Marker
          key={"customer"}
          position={{
            lat: parseFloat(props.customer.latitude),
            lng: parseFloat(props.customer.longitude),
          }}
          icon={{
            url: PinSource,
            scaledSize: getSize(),
            labelOrigin: getPoint(),
          }}
        />
      )}
      {/* Hospital/destino */}
      {props.nosocomio?.latitude && (
        <Marker
          key={"nosocomio"}
          position={{
            lat: parseFloat(props.nosocomio.latitude),
            lng: parseFloat(props.nosocomio.longitude),
          }}
          icon={{
            url: PinDestination,
            scaledSize: getSize(),
            labelOrigin: getPoint(),
          }}
        />
      )}
      {/* Posición actual */}
      {props.currentPosition && (
        <Marker
          key={"currentposicion"}
          position={props.currentPosition}
          icon={{
            url: PinCurrent,
            scaledSize: getSize(),
            labelOrigin: getPoint(),
          }}
        />
      )}
      {/* Rutas y paths */}
      {props.mode && props.mode === "inprogress" ? (
        <>
          {props.path1 && (
            <Polyline
              path={props.path1}
              options={{
                strokeColor: "#099107",
                strokeWeight: 7,
                strokeOpacity: 0.7,
              }}
            />
          )}
          {props.path2 && (
            <Polyline
              path={props.path2}
              options={{
                strokeOpacity: 0.7,
                strokeColor: "#01abc2",
                strokeWeight: 7,
              }}
            />
          )}
        </>
      ) : (
        <>
          {props.directions && props.directions.length > 1 && (
            <Polyline
              path={props.directions[1]}
              options={{
                strokeOpacity: 0.7,
                strokeWeight: 7,
                strokeColor: "#099107",
              }}
            />
          )}
          {props.directions && props.directions.length > 0 && (
            <Polyline
              path={props.directions[0]}
              options={{
                strokeOpacity: 0.7,
                strokeColor: props.colorStroke || "#01abc2",
                strokeWeight: 7,
              }}
            />
          )}
        </>
      )}
    </GoogleMap>
  );
};

const TransferMap: any = withScriptjs(withGoogleMap(TransferMapBase));
export default TransferMap; 